import * as React from 'react';
export const suncoastcuSvg = React.forwardRef(function suncoastcuSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EBF1F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 15.992C4 9.374 9.368 4 15.996 4S28 9.367 28 15.992C28 22.618 22.632 28 15.996 28 9.376 28 4 22.626 4 15.992Z',
      fill: '#FFE115',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 15.992C4 10.203 8.692 5.52 14.483 5.52c5.79 0 10.491 4.691 10.491 10.472S20.282 26.48 14.484 26.48A10.477 10.477 0 0 1 4 15.992Z',
      fill: '#FAC934',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.095 15.992c0-4.929 4.01-8.929 8.947-8.929 4.938 0 8.932 4 8.932 8.93 0 4.928-3.994 8.944-8.932 8.944-4.938 0-8.947-4.008-8.947-8.945Z',
      fill: '#F7943E',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.095 15.992c0-4.107 3.34-7.447 7.465-7.447 4.124 0 7.457 3.34 7.457 7.447 0 4.108-3.34 7.463-7.457 7.463-4.116 0-7.465-3.34-7.465-7.463Z',
      fill: '#EB762A',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.427 15.992a5.296 5.296 0 0 1 5.291-5.29c2.918 0 5.3 2.373 5.3 5.29a5.304 5.304 0 0 1-5.3 5.298 5.293 5.293 0 0 1-5.291-5.298Z',
      fill: '#E05D24',
    }),
  );
});
suncoastcuSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var suncoastcu = {
  category: 'brand',
  colorable: false,
  name: 'suncoastcu',
  svg: suncoastcuSvg,
};
